import type { AxiosError } from 'axios';
import { createQuery } from 'react-query-kit';

import { client } from '@/api/common';

type Variables = {};

export type BulkListDefaults = {
  hoursBetweenTrips: number;
  minHoursInAdvance: number;
  allowSubscription: boolean;
  supportsDelivery: boolean;
  maxDeliveryDistance: number | null;
  deliveryPersonPhone: string | null;
};

export const useBulkListDefaults = createQuery<
  BulkListDefaults,
  Variables,
  AxiosError
>({
  queryKey: ['partner/bulk-list-defaults'],
  fetcher: () => {
    return client
      .get(`v2/internal/partners/cars/bulk-list-defaults`)
      .then((response) => {
        return response.data.data;
      });
  },
});
